export function makeReturnUrl() {
    return `${window.location.pathname}${encodeURIComponent(window.location.search)}`;
}
